<template>
    <div class="reservation" v-show="visible">
        <div class="background" @click="hide"></div>

        <loader v-if="!hasLoaded"></loader>

        <div class="content" v-else>
            <div class="container">
                <div class="col-md-8">
                    <invoice :id="reservation.id" v-if="page == 'invoice'"></invoice>

                    <card v-if="page == 'products'">
                        <products :id="reservation.id" v-if="page == 'products'"></products>
                    </card>
                </div>

                <div class="col-md-4">
                    <card>
                        <strong>Total cost</strong><br />
                        <small>DKK</small> {{total | fixedNumber(2) | moneyFormat}}

                        <template v-if="reservation.room">
                            <hr />

                            <strong>Room</strong><br />
                            {{reservation.room.title}}
                        </template>

                        <template v-if="reservation.type">
                            <hr />

                            <strong>Payment</strong><br />
                            <multiselect placeholder="Type" v-model="selectedType" track-by="label" label="label" :options="typeOptions" :close-on-select="true" :show-labels="false"></multiselect>
                        </template>
                    </card>

                    <div class="list-group">
                        <router-link :to="{name: 'reservations.view', params: {id: reservation.id}}" class="list-group-item">
                            <span class="fa fa-pencil fa-fw"></span>&nbsp;&nbsp;
                            Edit reservation
                        </router-link>

                        <button class="list-group-item" @click="navigate('products')">
                            <span class="fa fa-shopping-cart fa-fw"></span>&nbsp;&nbsp;
                            Edit products
                        </button>

                        <button class="list-group-item" v-if="!paid" @click="markPaid">
                            <span class="fa fa-credit-card fa-fw"></span>&nbsp;&nbsp;
                            Mark as paid
                        </button>

                        <button class="list-group-item" v-else @click="markUnPaid">
                            <span class="fa fa-ban fa-fw text-danger"></span>&nbsp;&nbsp;
                            Mark as unpaid
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .reservation {
        position: fixed;

        width: 100%;
        height: 100%;

        left: 0;
        top: 0;

        z-index: 100;

        padding: 150px 0;

        overflow-y: scroll;

        .background {
            cursor: pointer;

            position: fixed;

            width: 100%;
            height: 100%;

            left: 0;
            top: 0;

            background: rgba(0, 0, 0, 0.8);
        }
    }
</style>

<script>
    import Card from '@/components/layout/Card'
    import Loader from '@/components/layout/Loader'
    import Invoice from '@/components/reservations/Invoice'
    import Products from '@/components/reservations/Products'
    import Multiselect from 'vue-multiselect'

    const ReservationService = require('@/services/reservations/ReservationService')
    const TypeService = require('@/services/reservations/TypeService')

    export default {
        data() {
            return {
                visible: false,
                reservation: null,
                hasLoaded: false,
                page: 'invoice',
                paid: false,

                types: [],
                selectedType: null,
            }
        },

        watch: {
            $route() {
                this.visible = false
            },

            visible() {
                this.page = 'invoice'

                if (!this.visible) {
                    document.body.className = ''
                    return
                }

                document.body.className = 'locked'
            },

            selectedType() {
                if (this.selectedType.value === this.reservation.type.id) {
                    return
                }

                ReservationService.update(this.reservation.id, {
                    type: this.selectedType.value
                })
            },

            types() {
                if (!this.reservation) {
                    return
                }

                this.matchType()
            }
        },

        computed: {
            total() {
                const reservation = this.reservation

                if (!reservation) {
                    return 0
                }

                let total = 0

                total += reservation.price
                total += reservation.totalPriceBreakfast
                total += reservation.totalProductPrice

                return total
            },

            typeOptions() {
                return this.types.map((type) => {
                    return {
                        label: type.title,
                        value: type.id
                    }
                })
            }
        },

        mounted() {
            eventHub.$on('reservations.overlay', this.overlay)
            eventHub.$on('products.updated', this.navigateToInvoice)
        },

        destroyed() {
            eventHub.$off('reservations.overlay', this.overlay)
            eventHub.$off('products.updated', this.navigateToInvoice)
        },

        methods: {
            navigateToInvoice() {
                this.navigate('invoice')
            },

            overlay(id) {
                this.visible = true
                this.reservation = null

                this.load(id)
            },

            load(id) {
                this.reservation = null
                this.hasLoaded = false

                const options = {
                    includes: ['type', 'room']
                }

                ReservationService.find(id, options, (response) => {
                    this.reservation = response.data
                    this.hasLoaded = true

                    this.paid = this.reservation.paid
                    this.loadTypes()
                })
            },

            hide() {
                this.visible = false
            },

            navigate(page) {
                this.page = page
            },

            markPaid() {
                ReservationService.update(this.reservation.id, {paid: '1'}, () => {
                    eventHub.$emit('reservation.updated', {
                        room: this.reservation.room.id
                    })

                    this.paid = true
                })
            },

            markUnPaid() {
                ReservationService.update(this.reservation.id, {paid: '0'}, () => {
                    eventHub.$emit('reservation.updated', {
                        room: this.reservation.room.id
                    })

                    this.paid = false
                })
            },

            loadTypes() {
                TypeService.findAll({}, (response) => {
                    this.types = response.data.rows
                    this.hasLoaded = true
                })
            },

            matchType() {
                if (!this.reservation.type) {
                    return
                }

                const types = this.typeOptions.filter((type) => {
                    return type.value === this.reservation.type.id
                })

                if (!types.length) {
                    return
                }

                this.selectedType = types[0]
            }
        },

        components: {
            Card,
            Loader,
            Invoice,
            Products,
            Multiselect
        }
    }
</script>


// WEBPACK FOOTER //
// Overlay.vue?6401c2ae